
// 内容列表页面——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `page/contentList/index${i + 1}`,
  name: `page/contentListIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/contentList/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 内容列表页面——主流程，开始
    ...MainRoutes
  ]
}
